import { v4 as uuidv4 } from 'uuid';
import { QuoteParcel } from '../types/basket-types';

export const QuoteQueryParams = {
  CollectionCountryIso: 'coli',
  DestinationCountryIso: 'desti'
};

export const buildQuoteUrl = (
  origin: string,
  originPostcode: string | undefined,
  destination: string,
  destinationPostcode: string | undefined,
  parcels: QuoteParcel[]
) => {
  const col = `${QuoteQueryParams.CollectionCountryIso}=${origin}`;
  const collectionPostalCode = originPostcode ? `&cp=${originPostcode}` : '';

  const dest = `&${QuoteQueryParams.DestinationCountryIso}=${destination}`;
  const destinationPostalCode = destinationPostcode ? `&dp=${destinationPostcode}` : '';

  let parcelProps = `&p=1~${parcels[0].weight}`;

  if (parcels[0].height !== 0 && parcels[0].width !== 0 && parcels[0].length !== 0) {
    parcelProps += `|${parcels[0].length}|${parcels[0].width}|${parcels[0].height}|${parcels[0].value ?? 0}`;
  }

  if (parcels.length > 1) {
    for (let i = 1; i < parcels.length; i++) {
      parcelProps += `^1~${parcels[i].weight}`;

      if (parcels[i].height !== 0 && parcels[i].width !== 0 && parcels[i].length !== 0) {
        parcelProps += `|${parcels[i].length}|${parcels[i].width}|${parcels[i].height}|${parcels[i].value ?? 0}`;
      }
    }
  }

  return `?${col}${dest}${collectionPostalCode}${destinationPostalCode}${parcelProps}&mdd=0`;
};

export const parseParcelsUrlString = (
  parcelsText: string,
  addParcelContents: boolean = false,
  defaultCountryOfManufacture: string = 'GBR'
) => {
  if (!parcelsText)
    return [
      { id: uuidv4(), weight: 1, length: null, width: null, height: null, value: null, quantity: 1, contents: [] }
    ];

  return parcelsText
    .split('^')
    .flatMap((parcel) => {
      const [quantityStr, dimensionStr] = parcel.split('~');
      let quantity = parseInt(quantityStr, 10);

      if (isNaN(quantity)) quantity = 1;

      const dimensions = (dimensionStr || '').split('|').map(Number);
      const weight = dimensions[0] > 0 ? dimensions[0] : 0.1;
      const parcels: QuoteParcel[] = [];

      for (let i = 0; i < quantity; i++) {
        parcels.push({
          id: uuidv4(),
          quantity: 1,
          weight,
          length: dimensions[1] || null,
          width: dimensions[2] || null,
          height: dimensions[3] || null,
          value: dimensions[4] || null,
          contents: addParcelContents
            ? [
                {
                  id: uuidv4(),
                  quantity: 1,
                  description: '',
                  countryOfManufacture: defaultCountryOfManufacture,
                  tariffCode: '',
                  value: dimensions[4] || null
                }
              ]
            : []
        });
      }

      return parcels;
    })
    .filter(Boolean); // Remove any null entries
};
